import React from "react";
import classNames from "classnames";
import styles from "./Img.module.scss";

const Img = props => {
  const { src, style, className, width = 100, height = 100, fill = 'transparent', ...rest } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${width} ${height}`} height={height} width={width} className={classNames(styles.img, className)} style={{ backgroundImage: `url('${props.src}')`, backgroundColor: fill, ...style }} {...rest}>
      <rect width={width} height={height} fill="transparent"></rect>
    </svg>
  )
}
export default Img;